function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from "prop-types";
import { RouterLink as Link } from '../Router/';
import ButtonIntl from './ButtonIntl';
import ButtonUpload from './ButtonUpload';
import './Button.scss';

class Button extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderIcon", () => {
      let icon = this.props.icon;

      if (!icon) {
        return false;
      }

      if (icon && icon.imageUrl) {
        return React.createElement("i", {
          className: "admin-button__icon  material-icons"
        }, React.createElement("img", {
          src: icon.imageUrl,
          alt: ""
        }));
      }

      return React.createElement("i", {
        className: "admin-button__icon  material-icons"
      }, icon);
    });

    _defineProperty(this, "renderLabel", () => {
      const title = this.props.title || this.props.label || false;

      if (!title) {
        return false;
      }

      return React.createElement("i", {
        className: "admin-button__label"
      }, title);
    });

    _defineProperty(this, "renderToggle", () => {
      const onToggle = this.props.onToggle;

      if (!onToggle) {
        return false;
      }

      return React.createElement("div", {
        className: "admin-button__toggle  material-icons"
      }, "arrow_drop_down");
    });

    _defineProperty(this, "getClassName", () => {
      let _this$props = this.props,
          buttonType = _this$props.buttonType,
          type = _this$props.type,
          className = _this$props.className;

      if (!buttonType && type) {
        buttonType = type;
      }

      if (className) {
        return className;
      }

      let classNames = [];
      classNames.push("admin-button");

      if (buttonType) {
        classNames.push("admin-button--" + buttonType);
      }

      return classNames.join(' ');
    });
  }

  render() {
    const _this$props2 = this.props,
          intlLabel = _this$props2.intlLabel,
          style = _this$props2.style,
          url = _this$props2.url,
          value = _this$props2.value,
          role = _this$props2.role,
          controls = _this$props2.controls,
          tabindex = _this$props2.tabindex,
          selected = _this$props2.selected,
          expanded = _this$props2.expanded,
          disabled = _this$props2.disabled,
          haspopup = _this$props2.haspopup,
          target = _this$props2.target,
          onClick = _this$props2.onClick,
          onToggle = _this$props2.onToggle,
          onUpload = _this$props2.onUpload,
          onMouseDown = _this$props2.onMouseDown;

    if (this.context.intl && intlLabel) {
      return React.createElement(ButtonIntl, this.props);
    }

    const className = this.getClassName();

    if (onUpload) {
      return React.createElement(ButtonUpload, this.props);
    }

    if ((url || onClick) && onToggle) {
      return React.createElement("div", {
        className: className,
        style: style,
        "aria-selected": selected,
        "aria-haspopup": haspopup,
        "aria-expanded": expanded
      }, React.createElement(Button, _extends({}, this.props, {
        className: false,
        children: false,
        haspopup: false,
        expanded: false,
        selected: false,
        onToggle: undefined
      })), React.createElement("div", {
        className: "admin-button__toggle  material-icons",
        onClick: onToggle
      }, "arrow_drop_down"));
    }

    if (url) {
      return React.createElement(Link, {
        to: url,
        className: className,
        style: style,
        onClick: onClick,
        target: target,
        tabIndex: tabindex,
        controls: controls,
        haspopup: haspopup,
        selected: selected,
        expanded: expanded
      }, this.renderIcon(), this.renderLabel(), this.props.children);
    }

    if (onToggle) {
      return React.createElement("button", {
        className: className,
        style: style,
        onClick: onToggle,
        value: value,
        disabled: disabled,
        "aria-haspopup": haspopup,
        "aria-selected": selected,
        "aria-expanded": expanded
      }, this.renderIcon(), this.renderLabel(), this.renderToggle(), this.props.children);
    }

    return React.createElement("button", {
      className: className,
      style: style,
      onClick: onClick,
      onMouseDown: onMouseDown,
      onToggle: onToggle,
      tabIndex: tabindex,
      role: role,
      value: value,
      disabled: disabled,
      "aria-controls": controls,
      "aria-haspopup": haspopup,
      "aria-selected": selected,
      "aria-expanded": expanded
    }, this.renderIcon(), this.renderLabel(), this.props.children);
  }

}

_defineProperty(Button, "contextTypes", {
  intl: PropTypes.object
});

export default Button;